<template>
  <div class="course_management_wrap" v-loading="loading">
    <!-- header 搜索 -->
    <div class="course_management_title">
      <h2>授权管理</h2>
      <div class="title_search">
        <el-select filterable v-model="shareOfcourse" placeholder="请选择授权课程" @change="searchBtn()" @clear="searchBtn()" clearable size="mini">
          <el-option v-for="(item,i) in allShareOfCourses" :key="i" :label="item.name" :title="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select filterable v-model="shareOfacademy" placeholder="请选择授权院校" @change="searchBtn()" @clear="searchBtn()" clearable size="mini">
          <el-option ption v-for="(item,i) in allShareOfAcademies" :key="i" :label="item.name" :title="item.name" :value="item.id"></el-option>
        </el-select>
        <div>
          <el-date-picker type="date" placeholder="开始授权日期" value-format="yyyy-MM-dd" v-model="startTime" style="width: 135px;" size="mini" @change="datamy(0)"></el-date-picker>
            -
          <el-date-picker type="date" placeholder="结束授权日期" value-format="yyyy-MM-dd" v-model="endTime" style="width: 135px;" size="mini" @change="datamy(0)"></el-date-picker>
        </div>
        <el-select v-model="shareOftype" placeholder="请选择授权状态" @change="searchBtn()" @clear="searchBtn()" clearable size="mini">
          <el-option v-for="(item,i) in allShareOfTypes" :key="i" :label="item.value" :value="item.typeId"></el-option>
        </el-select>
        <el-button class="header_button" @click="searchBtn()">查询</el-button>
      </div>
    </div>
    <div class="courseData_content">
      <div class="courseData_title">
        <span>已授权课程</span>
        <el-button v-if="$_has('zledu.jiaoxue.curriculum.save')" class="header_button" @click="add_tga" >添加授权</el-button>
      </div>
    </div>
    <!-- 表 -->
    <div class="table_taggle" :style="'padding-bottom:'+(tableData.length?'0':'16')+'px'">
      <el-table :data="tableData" :header-cell-style="{background:'#EDF4FE'}" :row-style="{ border: 0 }" :height="tableData.length?windowHeight-245:windowHeight-205" style="width: 100%">
        <el-table-column prop="index" width="100" label="序号"></el-table-column>
        <el-table-column prop="courseNameStr" label="授权课程"></el-table-column>
        <el-table-column prop="schoolIdsLen" label="授权院校数量"></el-table-column>
        <el-table-column prop="DurationOfAuthorization" label="授权期限"></el-table-column>
        <el-table-column prop="audiTimeStr" label="授权时间"></el-table-column>
        <el-table-column prop="statusStr" label="授权状态"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click.native.prevent="editBtn(1, scope.row)" round size="small">编辑</el-button>
            <el-button @click.native.prevent="deleteBtn(scope.row)" round size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加授权 -->
    <el-dialog title="添加授权" width="600px" :close-on-press-escape="false" :close-on-click-modal="false" height="400px" :visible.sync="dialogVisible">
      <div class="from_main">
        <el-form ref="form" label-width="120px">
          <el-form-item label="需授权课程">
            <el-button type="text" @click="editBtn(0, courses)">
              <span class="el-icon-plus" style="margin-bottom: 0px;"></span>选择课程
            </el-button>
            <ul>
              <li v-for="item in courses" :key="item.id">
                <el-tag size="mini" effect="plain" :closable="true" @close="close_tag(item.id, 0)">
                  <el-tooltip v-if="item.name.length > 13" :content="item.name" placement="bottom" effect="light">
                    <span class="check_span3">{{ item.name }}</span>
                  </el-tooltip>
                  <span class="check_span3" v-else>{{ item.name }}</span>
                </el-tag>
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="授权院校">
            <el-button type="text" @click="editBtn(1, schools)">
              <span class="el-icon-plus"></span>选择院校
            </el-button>
            <ul>
              <li v-for="item in schools" :key="item.id">
                <el-tag size="mini" effect="plain" :closable="true" @close="close_tag(item.id, 1)">
                  <el-tooltip v-if="item.name.length > 26" :content="item.name" placement="bottom" effect="light">
                    <span class="check_span3">{{ item.name }}</span>
                  </el-tooltip>
                  <span class="check_span3" v-else>{{ item.name }}</span>
                </el-tag>
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="授权日期">
            <el-col :span="8">
              <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="startDate" style="width: 135px;" size="mini" @change="datamy(1)" :picker-options="pickerOptions0"></el-date-picker>
            </el-col>
            <el-col class="line" :span="1">-</el-col>
            <el-col :span="7">
              <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="endDate" style="width: 135px;" size="mini" @change="datamy(1)" :picker-options="pickerOptions0"></el-date-picker>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="desFlag" size="mini" @click="saveData">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择院校 选择课程弹框 -->
    <el-dialog :title="dialogTitle" width="650px" height="400px" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogVisible2">
      <div class="sudent-content">
        <div class="selected tobe">
          <div class="seach">
            <el-checkbox :indeterminate="isIndeterminateLeft" v-model="checkAllLeft" v-if="dialogLeftList.length" @change="dialogHandleCheckAllChangeLeft" style="margin-right: 0px;"></el-checkbox>
            <span v-else style="display: inline-block;width: 15px;" ></span>
            <span style="margin-left: -15px;">待选</span>
            <div class="training-site">
              <el-input clearable @clear="clearFilter(1)" v-model="queryValLeft" :placeholder="dialogPlaceholder" size="mini" style="width: 160px; height: 28px;" @input.native="dialogFilter(1, $event)" @keyup.enter.native="dialogFilter(1)">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </div>
          <div class="left-table">
            <ul ref="ul_left" class="dialog_list" v-if="dialogLeftList.length > 0">
              <li v-for="(item, index) in dialogLeftList.slice(0,100)" :key="index">
                <el-checkbox-group v-model="dialogLeftCheckedTopic" @change="handleCheckedTopicChangeLeft" class="single_topic_checkbox">
                  <el-checkbox :label="item.id" :key="item.id" :title="item.name">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </li>
              <p v-if="dialogLeftList.length > 100" style="font-size: 12px;text-align: center;color: #cccccc;"> - 未全部加载完，请搜索查询 - </p>
            </ul>
            <p class="dialog_list" v-else style="text-align: center;color: #606266;">暂无数据</p>
          </div>
        </div>
        <!-- button  -->
        <div class="box_button">
          <el-button type="primary" @click="transfer(1)" :disabled="!dialogLeftCheckedTopic.length" class="button_top" icon="el-icon-arrow-right" circle></el-button>
          <el-button type="primary" @click="transfer(2)" :disabled="!dialogRightCheckedTopic.length" icon="el-icon-arrow-left" circle></el-button>
        </div>
        <!-- 已选 -->
        <div class="selected">
          <div class="seach">
            <el-checkbox :indeterminate="isIndeterminateRight" v-model="checkAllRight" v-if="dialogRightList.length" @change="dialogHandleCheckAllChangeRight" style="margin-right: 0px;"></el-checkbox>
            <span v-else style="display: inline-block;width: 15px;" ></span>
            <span style="margin-left: -15px;">已选</span>
            <div class="training-site">
              <el-input clearable @clear="clearFilter(2)" v-model="queryValRight" :placeholder="dialogPlaceholder" size="mini" style="width: 160px; height: 28px;" @input.native="dialogFilter(2, $event)" @keyup.enter.native="dialogFilter(2)">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </div>
          <div class>
            <ul ref="ul_right" class="dialog_list" v-if="dialogRightList.length > 0">
              <li v-for="(item, index) in dialogRightList.slice(0,100)" :key="index">
                <el-checkbox-group v-model="dialogRightCheckedTopic" @change="handleCheckedTopicChangeRight" class="single_topic_checkbox">
                  <el-checkbox :label="item.id" :key="item.id" :title="item.name">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </li>
              <p v-if="dialogRightList.length > 100" style="font-size: 12px;text-align: center;color: #cccccc;"> - 未全部加载完，请搜索查询 - </p>
            </ul>
            <p class="dialog_list" v-else style="text-align: center;color: #606266;">暂无数据</p>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px;padding-left: 20px;" v-show="!dialogVisible">
        授权日期
        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="dialogStartDate" style="width: 135px;margin-left: 20px;" size="mini" @change="datamy(2)" :picker-options="pickerOptions0"></el-date-picker>-
        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="dialogEndDate" style="width: 135px;" size="mini" @change="datamy(2)" :picker-options="pickerOptions0"></el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm" :disabled="dialogLeftCheckedTopic.length>0 || dialogRightCheckedTopic.length>0">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 分页 -->
    <el-pagination
      v-if="pageTotal.total > 10"
      :page-size="pageTotal.pageSize"
      @current-change="getList()"
      @size-change="getList()"
      background
      :current-page.sync="pageTotal.currentPage"
      layout="sizes, prev, pager, next, jumper"
      :total="pageTotal.total"
    ></el-pagination>
  </div>
</template>
<script>
  import * as api from '../../../../api/educationalApi'
  export default {
    data() {
      return {
        input: "",
        loading: false,
        desFlag: false,
        windowHeight: window.innerHeight, // 表格高度根据窗口高度来决定
        choice_list: [], // 选择课程 选择院校 请求列表
        choice_list_city: [], // 选择课程 选择院校 请求列表
        ChoosingCourses: [], // 被选中的课程 院校   tag
        placeholder: "", // 选择课程 选择院校 placeholder
        title: "",
        type: "",
        titles: [{ name: "选择课程" }, { name: "选择院校" }],
        typeData: [
          { index: 0, name: "授权中的课程" },
          { index: 1, name: "获得的授课课程" }
        ],
        tableData: [],
        schools: [], // 院校
        courses: [], // 课程
        startTime: '',
        endTime: '',
        startDate: "", //开始时间
        endDate: "", //结束时间
        checkAll: false,
        isIndeterminate: false,
        checkedCities: [],
        // 头部查询
        shareOfcourse: "", // 授权课程
        allShareOfCourses: [], // 所有课程
        shareOfacademy: "", // 授权院校
        allShareOfAcademies: [], // 所有院校
        shareOftimes: "", // 授权时间
        shareOftype: "", // 授权状态
        allShareOfTypes: [
          { typeId: 0, value: "过期" },
          { typeId: 1, value: "有效" }
        ], // 所有状态
        // dialog - 添加授权
        dialogVisible: false, // 添加授权 弹框
        // dialog - 课程&院校
        dialogVisible2: false, // 选择课程 选择院校 弹框
        dialogTitle: "",
        dialogPlaceholder: "",
        isIndeterminateLeft: false,
        isIndeterminateRight: false,
        checkAllLeft: false, // 全选按钮
        checkAllRight: false, // 全选按钮
        queryValLeft: "",
        queryValRight: "",
        dialogLeftList: [],
        dialogLeftListTemporary: [],
        dialogLeftCheckedTopic: [],
        dialogRightList: [],
        dialogRightListTemporary: [],
        dialogRightCheckedTopic: [],
        dialogStartDate: "",
        dialogEndDate: "",
        dialogEditBatchNo: '',
        dialogEditCourses: [],
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        tagList: [],
        table_student: [], //  选中学生列表 待选
        table_student2: [], //  选中学生列表  选中
				pageTotal: {
					currentPage: 1,
					pageSize: 10,
					total: 0,
				},
      };
    },
    created() {
      this.getList();
      this.queryCourseListOrInfos(0);
      this.queryCourseListOrInfos(1);
    },
    methods: {
      // 查询课程列表 or 院校列表
      queryCourseListOrInfos(type) {
        // 0 -> 课程列表; 1 -> 院校列表
        let API_URL = null;
        if (type == 0) {
          API_URL = api.queryCourseList()
        } else if (type == 1) {
          API_URL = api.queryDeptList()
        }
        API_URL.then(data => {
          let dataList = type == 0 ? data.data : data;
          dataList.forEach(item => {
            if (item.name || item.courseName) {
              if (type == 0) {
                this.allShareOfCourses.push({
                  name: item.courseName,
                  id: item.id
                });
              } else if (type == 1) {
                this.allShareOfAcademies.push({
                  name: item.name,
                  id: item.deptId
                });
              }
            }
          });
        }, e => {
          console.log(e);
        });
      },
      getList() {
        if (this.startTime == null) { this.startTime = "";}
        if (this.endTime == null) { this.endTime = "";}
        if ( this.startTime != "" && this.endTime == "") {
          this.$messageWarning('请选择结束授权时间')
          return false;
        };
        if ( this.endTime != "" && this.startTime == "") {
          this.$messageWarning('请选择开始授权时间')
          return false;
        };
        let params = {
          courseId: this.shareOfcourse, // 课程
          endTimieStr: this.endTime,
          pageNum: this.pageTotal.currentPage,
          pageSize: this.pageTotal.pageSize,
          schoolId: this.shareOfacademy, // 院校
          startTimeStr: this.startTime,
          status: this.shareOftype // 状态
        };
        // 获取数据列表
        this.tableData = [];
        this.loading = true;
        api.getAuthList(params).then( data => {
          if (data.code === "0") {
            this.tableData = data.data.list;
            this.tableData.forEach((item, index) => {
              item.courseNameStr = `《${item.courseName}》`;
              item.schoolIdsLen = item.schoolIds.length;
              item.index = (this.pageTotal.currentPage - 1) * 10 + (index + 1);
              item.DurationOfAuthorization = `${item.startTime.substr(0, 10)}至${item.endTime.substr(0, 10)}`;
              item.audiTimeStr = item.audiTime.substr(0, 10);
              item.statusStr = item.status == 0 ? "过期" : "有效";
            });
            this.pageTotal.total = data.data.total;
            this.loading = false;
          } else {
            this.$messageError(data.msg)
          }
        },e => {
            this.loading = false;
        });
      },
      searchBtn() {// 查询
        // this.pageTotal.currentPage = 1;
        this.getList();
      },
			handleCurrentChange(val) {//分页
				this.loading = true;
	      this.pageTotal.currentPage = val;
	      this.getList()
	   	},
	   	handleSizeChange(val){//分页
				this.loading = true;
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.getList()
      },
      add_tga() {// 添加授权
        this.dialogVisible = true;
        this.courses = [];
        this.startDate = "";
        this.endDate = "";
        this.schools = [];
        this.ChoosingCourses = [];
      },
      datamy(n) {// 验证选择结束的时间
        if (n == 0) {
          if (new Date(this.startTime).getTime() - new Date(this.endTime).getTime() > 0 && this.endTime != "") {
            this.endTime = "";
            this.$messageWarning('结束时间有误')
            return;
          };
          this.searchBtn();
        } else if (n == 1) {
          if (new Date(this.startDate).getTime() - new Date(this.endDate).getTime() > 0 && this.endDate != "") {
            this.endDate = "";
            this.$messageWarning('结束时间有误')
            return;
          }
        } else if (n == 2) {
          if (
            new Date(this.dialogStartDate).getTime() - new Date(this.dialogEndDate).getTime() > 0 &&
            this.dialogEndDate != ""
          ) {
            this.dialogEndDate = "";
            this.$messageWarning('结束时间有误')
          }
        }
      },
      dialogHandleCheckAllChangeLeft(val) {// 全选
        this.dialogLeftCheckedTopic = [];
        if (val) {
          this.dialogLeftList.forEach(item => {
            this.dialogLeftCheckedTopic.push(item.id);
          });
        } else {
          this.checkAllLeft = false;
          this.dialogLeftCheckedTopic = [];
        }
        this.isIndeterminateLeft = false;
      },
      dialogHandleCheckAllChangeRight(val) {
        this.dialogRightCheckedTopic = [];
        if (val) {
          this.dialogRightList.forEach(item => {
            this.dialogRightCheckedTopic.push(item.id);
          });
        } else {
          this.checkAllRight = false;
          this.dialogRightCheckedTopic = [];
        }
        this.isIndeterminateRight = false;
      },
      handleCheckedTopicChangeLeft(value) {// 非全选
        let checkedCount = value.length;
        this.checkAllLeft = checkedCount === this.dialogLeftList.length;
        this.isIndeterminateLeft = checkedCount > 0 && checkedCount < this.dialogLeftList.length;
      },
      handleCheckedTopicChangeRight(value) {
        let checkedCount = value.length;
        this.checkAllRight = checkedCount === this.dialogRightList.length;
        this.isIndeterminateRight = checkedCount > 0 && checkedCount < this.dialogRightList.length;
      },
      editBtn(num, data) {// 编辑授权
        // 0 -> 课程，1 -> 院校
        // console.log(data);
        this.isIndeterminateLeft = false;
        this.isIndeterminateRight = false;
        this.checkAllLeft = false;
        this.checkAllRight = false;
        this.queryValLeft = "";
        this.queryValRight = "";
        this.dialogLeftList = [];
        this.dialogLeftListTemporary = [];
        this.dialogLeftCheckedTopic = [];
        this.dialogRightList = [];
        this.dialogRightListTemporary = [];
        this.dialogRightCheckedTopic = [];
        this.dialogStartDate = "";
        this.dialogEndDate = "";
        this.dialogBatchNo = '';
        this.dialogEditCourses = [];
        this.dialogBatchNo = data.batchNo;
        this.dialogEditCourses.push(data.courseId);
        if (num == 0) {
          this.dialogTitle = "课程授权";
          this.dialogPlaceholder = "请输入课程名称";
          this.dialogLeftList = JSON.parse(
            JSON.stringify(this.allShareOfCourses)
          );
          this.dialogLeftListTemporary = this.dialogLeftList;
          if (data.length > 0) {
            data.forEach(item => {
              this.dialogLeftList.forEach((val, index) => {
                if (val.id == item.id) {
                  this.dialogLeftList.splice(index, 1);
                }
              });
            });
            this.dialogLeftListTemporary = this.dialogLeftList;
            this.dialogRightList = JSON.parse(JSON.stringify(data));
          }
        } else if (num == 1) {
          this.dialogTitle = "院校授权";
          this.dialogPlaceholder = "请输入院校名称";
          this.dialogLeftList = JSON.parse(
            JSON.stringify(this.allShareOfAcademies)
          );
          this.dialogLeftListTemporary = this.dialogLeftList;
          if (data.schoolIds != undefined &&  data.schoolIds.length > 0 ) {
            data.schoolIds.forEach(val => {
              this.allShareOfAcademies.forEach(item => {
                if (item.id == val) {
                  this.dialogRightList.push({
                    id: item.id,
                    name: item.name
                  });
                  // this.dialogRightCheckedTopic.push(item.deptId);
                  this.dialogLeftList.forEach(
                    (delete_val, index) => {
                      if (delete_val.id == item.id) {
                        this.dialogLeftList.splice(
                          index,
                          1
                        );
                      }
                    }
                  );
                }
              });
            });
            this.dialogLeftListTemporary = this.dialogLeftList;
            this.dialogRightListTemporary = this.dialogRightList;
            this.dialogStartDate = data.DurationOfAuthorization.slice(0,10);
            this.dialogEndDate = data.DurationOfAuthorization.slice(11);
          } else if (data.length > 0) {
            data.forEach(item => {
              this.dialogLeftList.forEach((val, index) => {
                if (val.id == item.id) {
                  this.dialogLeftList.splice(index, 1);
                }
              });
            });
            this.dialogLeftListTemporary = this.dialogLeftList;
            this.dialogRightList = JSON.parse(JSON.stringify(data));
          }
        }
        this.dialogVisible2 = true;
        this.$nextTick(() => {
          if (this.$refs.ul_left) {
            this.$refs.ul_left.scrollTop = 0;
          }
          if (this.$refs.ul_right) {
            this.$refs.ul_right.scrollTop = 0;
          }
        });
      },
      deleteBtn(data) {// 删除授权
        let params = {
          batchNo: data.batchNo,
          courseId: data.courseId,
          schoolId: this.shareOfacademy,
        };
        this.$confirm("确定删除该条数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          api.deleteAuth(params).then(res => {
            if (res.code == "0") {
              this.$messageSuccess('删除成功')
              this.searchBtn();
            } else {
              this.$messageError(res.msg)
            }
          }).catch(err => {
            console.log(err);
          });
        }).catch(() => {
          this.$messageInfo('已取消')
        });
      },
      transfer(n) {// 穿梭框
        // 1 -> 左侧移到右侧；2 -> 右侧移到左侧
        if (n == 1) {
          this.dialogLeftCheckedTopic.forEach(item => {
            this.dialogLeftList.forEach((val, index) => {
              if (val.id == item) {
                this.dialogRightList.push(
                  this.dialogLeftList[index]
                );
                this.dialogLeftList.splice(index, 1);
                // this.dialogRightCheckedTopic.push(item);
              }
            });
            this.dialogLeftListTemporary.forEach((val,index)=>{
              if (val.id == item) {
                this.dialogLeftListTemporary.splice(index, 1);
              }
            });
          });
          this.dialogLeftCheckedTopic = [];
          this.dialogRightList.sort(this.getSortFun("asc", "id"));
          this.dialogRightListTemporary = this.dialogRightList;
          this.checkAllLeft = false;
          this.isIndeterminateLeft = false;
          this.handleCheckedTopicChangeRight(this.dialogRightCheckedTopic);
        } else if (n == 2) {
          this.dialogRightCheckedTopic.forEach(item => {
            this.dialogRightList.forEach((val, index) => {
              if (val.id == item) {
                this.dialogLeftList.push(this.dialogRightList[index]);
                this.dialogRightList.splice(index, 1);
              }
            });
            this.dialogRightListTemporary.forEach((val,index)=>{
              if (val.id == item) {
                this.dialogRightListTemporary.splice(index, 1);
              }
            })
          });
          this.dialogRightCheckedTopic = [];
          this.dialogLeftList.sort(this.getSortFun("asc", "id"));
          this.dialogLeftListTemporary = this.dialogLeftList;
          this.checkAllRight = false;
          this.isIndeterminateRight = false;
          this.handleCheckedTopicChangeLeft(this.dialogLeftCheckedTopic);
        }
      },
      getSortFun(order, sortBy) {// 按id排序
        var ordAlpah = order == "asc" ? ">" : "<";
        var sortFun = new Function(
            "a",
            "b",
            "return a." + sortBy + ordAlpah + "b." + sortBy + "?1:-1"
        );
        return sortFun;
      },
      dialogFilter(n, event) {// dialog 筛选
        // 1 -> left; 2 -> right
        if (n == 1) {
          let str = event.data ? event.data : this.queryValLeft;
          this.dialogLeftList = this.dialogLeftListTemporary;
          let arr = [];
          this.dialogLeftList.forEach(item => {
            if (item.name.indexOf(str) != -1) {
              arr.push(item);
            }
          });
          this.dialogLeftList = arr;
        } else if (n == 2) {
          let str = event.data ? event.data : this.queryValRight;
          this.dialogRightList = this.dialogRightListTemporary;
          let arr = [];
          this.dialogRightList.forEach(item => {
            if (item.name.indexOf(str) != -1) {
              arr.push(item);
            }
          });
          this.dialogRightList = arr;
        }
      },
      clearFilter(n) {// dialog 清空筛选条件
        // 1 -> left; 2 -> right
        if (n == 1) {
          this.dialogLeftList = this.dialogLeftListTemporary;
        } else if (n == 2) {
          this.dialogRightList = this.dialogRightListTemporary;
        }
      },
      dialogConfirm() {// dialog - 确定
        if (this.dialogVisible) {
          // 添加授权
          if (this.dialogTitle == "课程授权") {
            this.courses = this.dialogRightList;
          } else if (this.dialogTitle == "院校授权") {
            this.schools = this.dialogRightList;
          }
          this.dialogVisible2 = false;
        } else {
          if (!this.dialogStartDate) {
            this.$messageWarning('请选择开始时间')
            return false;
          } else if (!this.dialogEndDate) {
            this.$messageWarning('请选择结束时间')
            return false;
          } else if (new Date(this.dialogStartDate).getTime() > new Date(this.dialogEndDate).getTime()) {
            this.$messageWarning('结束时间不正确')
            return false;
          };
          if (this.dialogRightList.length == 0) {
            this.$messageWarning('授权院校不能为空！')
            return false;
          };
          let arr = [];
          this.dialogRightList.forEach(item=>{
            arr.push(item.id);
          });
          // 编辑
          let params = {
            batchNo: this.dialogBatchNo,
            courses: this.dialogEditCourses,
            endTime: this.dialogEndDate.split("-").join(''),
            schools: arr,
            startTime: this.dialogStartDate.split("-").join(''),
          };
          // return;
          api.updateAuth(params).then(res=>{
            if (res.code == '0') {
              this.$messageSuccess('保存成功')
              this.dialogVisible2 = false;
              this.searchBtn();
            } else {
              this.$messageError(res.msg)
            }
          }).catch(err=>{
              console.log(err);
          })
        }
      },
      dialogCancel() {// dialog - 取消
        this.dialogBatchNo = '';
        this.dialogEditCourses = [];
        this.dialogVisible2 = false;
      },
      close_tag(id, n) {
        // 0 -> 课程courses；1 -> 院校schools
        if (n == 0) {
          for (var t = 0; t < this.courses.length; t++) {
            if (this.courses[t].id == id) {
              this.courses.splice(t, 1);
              break;
            }
          }
        } else if (n == 1) {
          for (var l = 0; l < this.schools.length; l++) {
            if (this.schools[l].id == id) {
              this.schools.splice(l, 1);
              break;
            }
          }
        }
      },
      choice(type) {
        // 选择课程 选择院校
        this.type = type; // 课程  0
        this.title = this.titles[type].name;
        this.dialogVisible2 = true;
        this.input = "";
        this.choice_list = [];
        this.ChoosingCourses = [];
        let API_URL = null;
        if (type == 0) {
          this.placeholder = "请输入课程名称";
          API_URL =  api.queryCourseList()
        } else if (type == 1) {
          this.placeholder = "请选择院校名称";
          API_URL = api.queryDeptList()
        }
        API_URL.then(data => {
          let dataList = type == 0 ? data.data : data;
          dataList.forEach(item => {
            if (item.name || item.courseName) {
              this.choice_list.push({
                name: type == 0 ? item.courseName : item.name,
                id: type == 0 ? item.id : item.deptId
              });
            }
          });
          // 回显 选中
          if (type == 0 && this.courses.length) {
            // 课程
            for (let i = 0; i < this.courses.length; i++) {
              for (let j = 0; j < this.choice_list.length; j++) {
                if (this.choice_list[j].id == this.courses[i].id) {
                  this.ChoosingCourses.push({
                    id: this.choice_list[j].id,
                    label: this.choice_list[j].name
                  });
                  break;
                }
              }
            }
          } else if (type == 1 && this.schools.length) {
            // 院校
            for (let i = 0; i < this.schools.length; i++) {
              for (let j = 0; j < this.choice_list.length; j++) {
                if (this.choice_list[j].id == this.schools[i].id) {
                  this.ChoosingCourses.push({
                    id: this.choice_list[j].id,
                    label: this.choice_list[j].name
                  });
                  break;
                }
              }
            }
          }
          this.choice_list_city = this.choice_list;
        },e => {
            console.log(e);
        });
      },
      dateToStr(datetime) {
        datetime.setDate(datetime.getDate());
        var year = datetime.getFullYear();
        var month = datetime.getMonth() + 1; //js从0开始取
        var date = datetime.getDate();
        month = month < 10 ? "0" + month : month;
        date = date < 10 ? "0" + date : date;
        return "" + year + month + date;
      },
      saveData() {
        this.desFlag = true;
        if (!this.schools.length) {
          this.$messageWarning('请选择院校')
          this.desFlag = false;
          return false;
        } else if (!this.courses.length) {
          this.$messageWarning('请选择选择课程')
          this.desFlag = false;
          return false;
        } else if (!this.startDate) {
          this.$messageWarning('请选择开始时间')
          this.desFlag = false;
          return false;
        } else if (!this.endDate) {
          this.$messageWarning('请选择结束时间')
          this.desFlag = false;
          return false;
        } else if (new Date(this.startDate).getTime() > new Date(this.endDate).getTime()) {
          this.$messageWarning('结束时间不正确')
          this.desFlag = false;
          return false;
        }
        let schools = [];
        for (var i = 0; i < this.schools.length; i++) {
          schools.push(this.schools[i].id);
        }
        let courses = [];
        for (var i = 0; i < this.courses.length; i++) {
          courses.push(this.courses[i].id);
        }
        this.desFlag = false;
        let data = {
          schools,
          courses,
          startTime: this.startDate.split("-").join(''),
          endTime: this.endDate.split("-").join(''),
        };
        this.desFlag = true;
        api.addAuth(data).then(data => {
          if (data.msg.indexOf("success") != -1) {
            this.$messageSuccess('授权成功')
            this.dialogVisible = false;
            this.startDate = "";
            this.endDate = "";
            this.schools = [];
            this.courses = [];
            this.getList();
          } else {
            this.$messageError(data.msg)
          }
          this.desFlag = false;
        }, e => {
          console.log(e);
          this.desFlag = false;
        });
      },
    }
};
</script>
<style lang="scss" scoped>
.header_button {
  padding: 7px 11px;
  border: solid 1px #5397f7;
  color: #5397f7;
  float: right;
  font-size: 10px;
}
.course_management_title {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.course_management_wrap {
  padding: 0 16px;
  background: #fff;
  margin: 16px 16px 0;
  border-radius: 4px;
  .course_management_title {
    height: 48px;
    border-bottom: 1px solid #5397f7;
    display: flex;
    align-items: center;
    position: relative;
    .title_search {
      width: 80%;
      display: flex;
      justify-content: space-between;
      /deep/ .el-select {
        width: 160px;
      }
      /deep/ .el-date-editor {
        width: 280px;
      }
    }
    h2 {
      border-left: 2px solid rgba(83, 151, 247, 1);
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
  }
  .courseData_content {
    overflow-y: auto;
    .courseData_title {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 14px;
        font-weight: bolder;
      }
    }
  }
  .from_main ul {
    max-height: 120px;
    overflow: auto;
    li {
      line-height: 30px;
    }
  }
  /deep/ .el-pagination{
    height:50px;
    display: flex;
    align-items: center;
    /deep/ .btn-next, /deep/ .btn-prev, /deep/ .el-pager li{
      background-color:#fff;
      height:24px;
      min-width: 24px;
      line-height: 22px;
      border:1px solid rgba(226,226,226,1);
      border-radius:4px;
      font-size:12px;
      font-weight:400;
      color:rgba(102,102,102,1);
      padding: 0 2px;
    }
    /deep/ .el-pager li:not(.disabled).active{
      background:#5397F7;
      color: #fff;
    }
  }
}
.AuthorizedObject_box {
  margin: 19px auto 20px;
}
.el-table {
  border-radius: 4px 4px 0px 0px;
  border: solid 1px #ebebeb;
  border-bottom: none;
}
/deep/ .el-dialog__header {
  background: #edf4ff;
  border-radius: 8px 8px 0 0;
  height: 18px;
  &:before {
    width: 2px;
    height: 10px;
    background: rgba(83, 151, 247, 1);
    opacity: 1;
    border-radius: 4px;
  }
}
/deep/ .el-dialog__title {
  display: block;
  font-size: 14px;
  color: #5397f7;
  border-left: 2px solid #5397f7;
  padding-left: 5px;
  line-height: 10px;
}
span.check_span3 {
  display: inline-block;
  max-width: 325px;
  /* overflow: hidden; */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/deep/ .el-checkbox__input {
  vertical-align: -2px;
}
/deep/ .el-checkbox__label {
  vertical-align: -5px;
}
/deep/ .el-tag--mini .el-icon-close {
  vertical-align: 4px;
}
/deep/ .el-button--small,
.el-button--small.is-round {
  padding: 5px 15px;
  color: #5397f7;
}
.active_list_mian {
  height: 212px;
  overflow-y: auto;
  overflow-x: hidden;
}

// 编辑课程
.sudent-content {
  display: flex;
  justify-content: space-around;
  .selected {
    width: 255px;
    height: 360px;
    border: 1px solid rgba(226, 226, 226, 1);
    border-radius: 4px;
    .seach {
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 13px 0 12px;
      /depp/ .el-checkbox {
        margin-right: 0px;
      }
      /deep/ .el-checkbox__input {
        position: relative;
        top: 1px;
        left: -1px;
      }
    }
    /deep/ .el-table {
      margin: 0 !important;
      border-left: 0;
      border-right: 0;
    }
    .dialog_list {
      height: 280px;
      padding: 10px;
      border-top: 1px solid rgba(226, 226, 226, 1);
      overflow: auto;
      li {
        line-height: 30px;
        /deep/ .el-checkbox__input {
          position: relative;
          top: 5px;
        }
        /deep/ .el-checkbox__label {
          font-weight: initial;
          display: inline-block;
          width: 200px;
          vertical-align: bottom;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      li:hover {
        /deep/ .el-checkbox__label {
          color: rgba(83, 151, 247, 1);
        }
      }
    }
  }
  .tobe {
    width: 255px;
  }
  .box_button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .button_top {
      margin-bottom: 8px;
    }
    /deep/ .el-button {
      padding: 0px 0px;
      margin-left: 0px;
      width: 32px;
      border-radius: 50%;
      height: 32px;
      i {
        color: #fff;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding: 15px 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educationalAdminMenu/courseSharing.vue